export const CONSENT_VERSION = 1;
const KEY = "cookie_consent";
const VERSION_KEY = "cookie_consent_version";

export const defaultConsent = () => ({
    functional: true,
    performance: false,
    marketing: false,
    updatedAt: new Date().toISOString(),
    version: CONSENT_VERSION,
});

export function loadConsent() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        const v = Number(localStorage.getItem(VERSION_KEY) ?? parsed.version ?? 0);

        if (v !== CONSENT_VERSION) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function saveConsent(consent) {
    const full = {
        ...defaultConsent(),
        ...consent,
        functional: true,
        updatedAt: new Date().toISOString(),
        version: CONSENT_VERSION,
    };
    localStorage.setItem(KEY, JSON.stringify(full));
    localStorage.setItem(VERSION_KEY, String(CONSENT_VERSION));
    return full;
}
